import { Box, BoxProps } from '@chakra-ui/react'

interface SwitchControlProps extends BoxProps {}

export const SwitchControl = ({ sx, ...rest }: SwitchControlProps) => {
  return <Box sx={{ display: 'inline-flex', gap: 2, alignItems: 'center', ...sx }} {...rest} />
}
